module.exports = __webpack_public_path__ + "img/gabe-16.48a86415.jpg";